import React, { useState } from 'react';
import { Button, Badge, Collapse } from 'react-bootstrap';
import { FaTrash, FaChevronDown, FaChevronRight } from 'react-icons/fa';
import Loading from '~/Components/Loading';

// V-25: só pode excluir ocorrências manuais (auto === 'N') do próprio usuário
const podeExcluir = (oco, codigoUsuario) =>
  oco.auto === 'N' && Number(oco.usuario) === Number(codigoUsuario);

const OcorrenciaItem = ({ oco, codigoUsuario, onExcluir }) => {
  const [aberto, setAberto] = useState(false);

  const dataFormatada = oco.data
    ? new Date(oco.data).toLocaleString('pt-BR')
    : '-';

  return (
    <div
      className="border rounded mb-2"
      style={{ fontSize: '0.85rem', overflow: 'hidden' }}
    >
      <div
        className="d-flex justify-content-between align-items-center px-2 py-1"
        style={{
          backgroundColor: oco.auto === 'S' ? '#e8f0fe' : '#fff8e1',
          cursor: 'pointer',
        }}
        onClick={() => setAberto((prev) => !prev)}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => { if (e.key === 'Enter') setAberto((prev) => !prev); }}
      >
        <div className="d-flex align-items-center">
          <span className="mr-2" style={{ color: '#888' }}>
            {aberto ? <FaChevronDown /> : <FaChevronRight />}
          </span>
          <strong>{oco.titulo || '(sem título)'}</strong>
          <Badge
            className="ml-2"
            style={{
              backgroundColor: oco.auto === 'S' ? '#4a90d9' : '#f5a623',
              color: '#fff',
              fontSize: '0.7rem',
            }}
          >
            {oco.auto === 'S' ? 'Auto' : 'Manual'}
          </Badge>
        </div>
        <div className="d-flex align-items-center" style={{ whiteSpace: 'nowrap' }}>
          <span className="text-muted mr-3" style={{ fontSize: '0.78rem' }}>
            {dataFormatada}
          </span>
          {podeExcluir(oco, codigoUsuario) && (
            <Button
              variant="outline-danger"
              size="sm"
              title="Excluir ocorrência"
              onClick={(e) => { e.stopPropagation(); onExcluir({ codigoCalc: oco.codigoCalc, data: oco.data }); }}
            >
              <FaTrash />
            </Button>
          )}
        </div>
      </div>
      <Collapse in={aberto}>
        <div className="px-3 py-2" style={{ whiteSpace: 'pre-wrap', backgroundColor: '#fafafa' }}>
          <div className="text-muted mb-1" style={{ fontSize: '0.78rem' }}>
            Por: {oco.nome_usuario || `#${oco.usuario}`}
          </div>
          {oco.texto || <em className="text-muted">Sem texto</em>}
        </div>
      </Collapse>
    </div>
  );
};

const OcorrenciaLista = ({ ocorrencias, codigoUsuario, onExcluir, loading }) => {
  if (loading) {
    return <div className="py-3"><Loading /></div>;
  }

  if (!ocorrencias || ocorrencias.length === 0) {
    return (
      <p className="text-center text-muted py-3">
        Nenhuma ocorrência registrada.
      </p>
    );
  }

  return (
    <div>
      <strong style={{ fontSize: '0.9rem' }}>
        Histórico ({ocorrencias.length})
      </strong>
      <div className="mt-2">
        {ocorrencias.map((oco) => (
          <OcorrenciaItem
            key={`${oco.codigoCalc}-${oco.data}`}
            oco={oco}
            codigoUsuario={codigoUsuario}
            onExcluir={onExcluir}
          />
        ))}
      </div>
    </div>
  );
};

export default OcorrenciaLista;
